import { render, staticRenderFns } from "./DashboardSuper.vue?vue&type=template&id=27354fce&scoped=true"
import script from "./DashboardSuper.vue?vue&type=script&lang=js"
export * from "./DashboardSuper.vue?vue&type=script&lang=js"
import style0 from "./DashboardSuper.vue?vue&type=style&index=0&id=27354fce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27354fce",
  null
  
)

export default component.exports